var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortingSelected = function SvgSortingSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "m8.192 1.23 3.714 4.458A.8.8 0 0 1 11.292 7H4.708a.8.8 0 0 1-.615-1.312L7.808 1.23a.25.25 0 0 1 .384 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87AACA",
    d: "m7.808 14.77-3.715-4.458A.8.8 0 0 1 4.708 9h6.584a.8.8 0 0 1 .614 1.312L8.192 14.77a.25.25 0 0 1-.384 0Z"
  })));
};
export default SvgSortingSelected;